import { withResponsiveBaseFallback } from './internal';
import { normalizeChildrenToNodes } from '../internal/children';
import { createNodeId } from '../render/node-id';
import { composeAsChildNode } from './as-child';
import { buildCommonUIProps, } from './common-props';
import { resolveCanonicalUtilityProps } from './utility-props';
export function buildFlexContainerNode(options) {
    const classes = [options.baseClass];
    if (options.className) {
        classes.push(options.className);
    }
    const resolvedGap = resolveResponsiveValueWithDefault(options.gap, options.defaultGap);
    const resolvedAlign = resolveResponsiveValueWithDefault(options.align, options.defaultAlign);
    const resolvedJustify = resolveResponsiveValueWithDefault(options.justify, options.defaultJustify);
    const resolvedWrap = resolveResponsiveValueWithDefault(options.wrap, options.defaultWrap);
    const resolvedDirection = resolveResponsiveValueWithDefault(options.direction, options.defaultDirection);
    const props = {
        className: classes.join(' '),
        ...(typeof options.as === 'string' && options.as.length > 0 && { 'data-as': options.as }),
        ...resolveInteractiveHostProps(options.utilityPropsInput),
        ...resolveCanonicalUtilityProps({
            ...options.utilityPropsInput,
            ...(options.display !== undefined && { display: options.display }),
            ...(resolvedGap !== undefined && { gap: resolvedGap }),
            ...(resolvedAlign !== undefined && { align: resolvedAlign }),
            ...(resolvedJustify !== undefined && { justify: resolvedJustify }),
            ...(resolvedWrap !== undefined && { wrap: resolvedWrap }),
            ...(options.emitDirectionProp && resolvedDirection !== undefined && { direction: resolvedDirection }),
        }),
        ...buildCommonUIProps({
            id: options.id,
            role: options.role,
            ariaLabel: options.ariaLabel,
            ariaLabelledBy: options.ariaLabelledBy,
            ariaDescribedBy: options.ariaDescribedBy,
            style: options.style,
            dataUi: options.dataUi,
            defaultDataUi: options.defaultDataUi,
        }),
    };
    const childNodes = normalizeChildrenToNodes(options.children);
    if (options.asChild) {
        return composeAsChildNode({
            componentType: options.componentType,
            props,
            children: options.children,
            explicitDataUi: options.dataUi,
            semanticTagOverride: options.as,
        });
    }
    return {
        id: createNodeId(),
        type: options.componentType,
        props,
        children: childNodes,
    };
}
function resolveInteractiveHostProps(props) {
    const hostProps = {};
    if (typeof props.disabled === 'boolean')
        hostProps.disabled = props.disabled;
    if (props.type === 'button' || props.type === 'submit' || props.type === 'reset')
        hostProps.type = props.type;
    if (typeof props.form === 'string')
        hostProps.form = props.form;
    if (typeof props.name === 'string')
        hostProps.name = props.name;
    if (typeof props.value === 'string' || typeof props.value === 'number')
        hostProps.value = props.value;
    if (typeof props.tabIndex === 'number')
        hostProps.tabIndex = props.tabIndex;
    if (typeof props.ariaDisabled === 'boolean')
        hostProps.ariaDisabled = props.ariaDisabled;
    for (const eventProp of ['onClick', 'onMouseEnter', 'onMouseLeave', 'onMouseDown', 'onFocus', 'onBlur', 'onKeyDown']) {
        if (typeof props[eventProp] === 'function') {
            hostProps[eventProp] = props[eventProp];
        }
    }
    return hostProps;
}
function resolveResponsiveValueWithDefault(value, fallbackValue) {
    if (value === undefined) {
        return fallbackValue;
    }
    if (fallbackValue === undefined) {
        return value;
    }
    return withResponsiveBaseFallback(value, fallbackValue);
}
//# sourceMappingURL=flex-layout.js.map